export const SPEED_SOLVE_COLOR = '#0ea5e9';
export const SPEED_PLAY_COLOR = '#059669';

export const SUCCESS_COLOR = '#059669';
